/* eslint-disable no-console */

// Registers the Vue CLI PWA service worker (dist/service-worker.js).
// Kept lightweight to avoid extra dependencies like `register-service-worker`.

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const baseUrl = process.env.BASE_URL || '/'
    const swUrl = `${baseUrl}service-worker.js`

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        console.log('[PWA] Service worker registered:', swUrl)

        registration.onupdatefound = () => {
          const installingWorker = registration.installing
          if (!installingWorker) return

          installingWorker.onstatechange = () => {
            if (installingWorker.state !== 'installed') return

            if (navigator.serviceWorker.controller) {
              console.log('[PWA] New content is available; refresh to update.')
            } else {
              console.log('[PWA] Content is cached for offline use.')
            }
          }
        }
      })
      .catch((error) => {
        console.error('[PWA] Service worker registration failed:', error)
      })
  })
}

